export const requests = { getTimeSlots: null };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/actions/requests.js